/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Mode_LabelInputs */

const en_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing Mode`)
};

const fr_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode de minutage`)
};

const de_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing-Modus`)
};

const it_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalità di temporizzazione`)
};

const ru_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим синхронизации`)
};

const es_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de sincronización`)
};

const zh_cn2_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定时模式`)
};

const ja_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングモード`)
};

const hi_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमिंग मोड`)
};

const pt_pt2_timing_sync_mode_label = /** @type {(inputs: Timing_Sync_Mode_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo de temporização`)
};

/**
* | output |
* | --- |
* | "Timing Mode" |
*
* @param {Timing_Sync_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_mode_label = /** @type {((inputs?: Timing_Sync_Mode_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Mode_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_mode_label(inputs)
	if (locale === "de") return de_timing_sync_mode_label(inputs)
	if (locale === "it") return it_timing_sync_mode_label(inputs)
	if (locale === "ru") return ru_timing_sync_mode_label(inputs)
	if (locale === "es") return es_timing_sync_mode_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_mode_label(inputs)
	if (locale === "ja") return ja_timing_sync_mode_label(inputs)
	if (locale === "hi") return hi_timing_sync_mode_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_mode_label(inputs)
	return en_timing_sync_mode_label(inputs)
});